import React, { useEffect, useState } from "react";
import { formatDateTime } from "../utils/formatDate";
import { Form, Spinner, Button  } from "react-bootstrap";
import {
  FaSearch,
  FaFilter,
  FaHistory,
  FaUserClock,
} from "react-icons/fa";
import axios from "axios";
import "../Styles/AdminPages.css";
import formatName from "../utils/formatName";

function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const logsPerPage = 10;

  const brandBlue = "#263F86";
  const softBlue = "rgba(95, 112, 245, 0.15)";
  const borderColor = "#EEF0F4";

  const fetchAuditLogs = async () => {
  setLoading(true);

  try {
    const params = new URLSearchParams();

    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    if (search) params.append("search", search);

    const response = await axios.get(
      `${process.env.REACT_APP_API}/getAuditLogs?${params.toString()}`
    );

    if (response.data.success) {
      setLogs(response.data.data || []);
      setCurrentPage(1);
    } else {
      setLogs([]);
    }
  } catch (error) {
    console.error("Error fetching audit logs:", error);
    setLogs([]);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  fetchAuditLogs();

  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  const indexOfLastLog = currentPage * logsPerPage;
  const indexOfFirstLog = indexOfLastLog - logsPerPage;
  const currentLogs = logs.slice(indexOfFirstLog, indexOfLastLog);
  const totalPages = Math.ceil(logs.length / logsPerPage);

  return (
    <section className="admin-page" aria-labelledby="audit-page-title">
      <div className="admin-page__header">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
          <div>
            <div style={{ textAlign: "left" }}>
              <p className="admin-page__eyebrow">ACTIVITY HISTORY</p>
              <h1 id="audit-page-title">Audit logs</h1>
              <p className="admin-page__intro">
                Track user activities, system actions, and audit history.
              </p>
            </div>
          </div>

          <div className="admin-page__metric"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              background: "#263F86",
              padding: "9px 13px",
              borderRadius: "14px",
              boxShadow: "0 6px 18px rgba(38, 63, 134, 0.15)",
              minWidth: "145px",
              height: "58px",
            }}
          >
            <div
              style={{
                width: "34px",
                height: "34px",
                borderRadius: "11px",
                background: "rgba(255,255,255,0.12)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                flexShrink: 0,
              }}
            >
              <FaHistory size={14} />
            </div>

            <div style={{ lineHeight: 1 }}>
              <div
                style={{
                  fontSize: "9px",
                  fontWeight: 700,
                  color: "rgba(255,255,255,0.72)",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  marginBottom: "5px",
                }}
              >
                Total Logs
              </div>

              <div
                style={{
                  fontSize: "22px",
                  fontWeight: 800,
                  color: "#ffffff",
                  textAlign: "right",
                }}
              >
                {logs.length}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="mb-4"
        style={{
          background: "#ffffff",
          borderRadius: "18px",
          padding: "18px 20px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.04)",
          border: `1px solid ${borderColor}`,
        }}
      >
        <div className="d-flex align-items-center gap-2 mb-3">
          <FaFilter color={brandBlue} />
          <h6 className="fw-bold mb-0">Filter Audit Logs</h6>
        </div>

        <div className="d-flex justify-content-between align-items-end flex-wrap gap-3">
          {/* LEFT SIDE */}
          <div className="d-flex flex-wrap gap-3">
            <div style={{ width: "180px", textAlign: "left" }}>
              <Form.Label
                className="fw-semibold mb-2"
                style={{
                  fontSize: "13px",
                  color: "#475569",
                  display: "block",
                }}
              >
                From Date
              </Form.Label>

              <Form.Control
                type="date"
                value={dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
                style={inputStyle}
              />
            </div>

            <div style={{ width: "180px", textAlign: "left" }}>
              <Form.Label
                className="fw-semibold mb-2"
                style={{
                  fontSize: "13px",
                  color: "#475569",
                  display: "block",
                }}
              >
                To Date
              </Form.Label>

              <Form.Control
                type="date"
                value={dateTo}
                onChange={(e) => setDateTo(e.target.value)}
                style={inputStyle}
              />
            </div>
          </div>

          {/* RIGHT SIDE */}
        <div style={{ minWidth: "320px", flex: 1, maxWidth: "520px" }}>
  <Form.Label
    className="fw-semibold mb-2"
    style={{
      fontSize: "13px",
      color: "#475569",
      display: "block",
      textAlign: "left",
    }}
  >
    Search
  </Form.Label>

  <div className="d-flex gap-2">
    <div style={{ position: "relative", flex: 1 }}>
      <FaSearch
        size={14}
        style={{
          position: "absolute",
          top: "50%",
          left: "14px",
          transform: "translateY(-50%)",
          color: "#5F6B7A",
        }}
      />

      <Form.Control
        type="text"
        placeholder="Username or activity"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            fetchAuditLogs();
          }
        }}
        style={{
          ...inputStyle,
          paddingLeft: "38px",
        }}
      />
    </div>

    <Button
      onClick={fetchAuditLogs}
      disabled={loading}
      style={{
        background: brandBlue,
        border: "none",
        borderRadius: "12px",
        padding: "0 16px",
        fontWeight: 700,
        fontSize: "13px",
      }}
    >
      Search
    </Button>
  </div>
</div>
        </div>
      </div>

      <div
        style={{
          background: "#ffffff",
          borderRadius: "18px",
          padding: "20px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.04)",
          border: `1px solid ${borderColor}`,
        }}
      >
        <div className="d-flex align-items-center gap-2 mb-3">
          <FaUserClock color={brandBlue} size={15} />
          <h6
            className="fw-bold mb-0"
            style={{
              color: "#1F2937",
              fontSize: "15px",
            }}
          >
            Audit Log List
          </h6>
        </div>

        {loading ? (
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ height: "50vh" }}
          >
            <Spinner animation="border" style={{ color: brandBlue }} />
            <p className="mt-3 mb-0">Loading audit logs...</p>
          </div>
        ) : currentLogs.length > 0 ? (
          <>
            <div className="table-responsive">
              <table
                className="table mb-0"
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  fontSize: "13px",
                }}
              >
                <thead>
                  <tr>
                    <th style={thStyle}>No</th>
                    <th style={thStyleLeft}>Username</th>
                    <th style={thStyleLeft}>Activity</th>
                    <th style={thStyle}>Activity Date</th>
                  </tr>
                </thead>

                <tbody>
                  {currentLogs.map((log, index) => (
                    <tr
                      key={log.id || index}
                      style={{
                        borderBottom: `1px solid ${borderColor}`,
                      }}
                    >
                      <td style={tdStyle}>{indexOfFirstLog + index + 1}</td>

                      <td style={tdStyleLeft}>
                        <div className="d-flex align-items-center gap-2">
                          <div
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "10px",
                              background: softBlue,
                              color: brandBlue,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: 800,
                              fontSize: "13px",
                              flexShrink: 0,
                            }}
                          >
                            {(log.username || "U").charAt(0).toUpperCase()}
                          </div>

                          <span
                            style={{
                              fontWeight: 700,
                              color: "#1F2937",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {formatName(log.username) || "-"}
                          </span>
                        </div>
                      </td>

                      <td
                        style={{
                          ...tdStyleLeft,
                          whiteSpace: "normal",
                          minWidth: "260px",
                        }}
                      >
                        {log.activity || "-"}
                      </td>

                      <td style={tdStyle}>
                        {formatDateTime(log.activity_date)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <nav aria-label="Page navigation" className="mt-4">
                <ul className="pagination justify-content-center flex-wrap gap-1">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((prev) => prev - 1)}
                      disabled={currentPage === 1}
                      style={{ borderRadius: "10px" }}
                    >
                      Previous
                    </button>
                  </li>

                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .filter(
                      (page) =>
                        page === 1 ||
                        page === totalPages ||
                        (page >= currentPage - 2 && page <= currentPage + 2),
                    )
                    .map((page) => (
                      <li
                        key={page}
                        className={`page-item ${
                          page === currentPage ? "active" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => setCurrentPage(page)}
                          style={{
                            borderRadius: "10px",
                            background:
                              page === currentPage ? brandBlue : "#fff",
                            borderColor:
                              page === currentPage ? brandBlue : borderColor,
                          }}
                        >
                          {page}
                        </button>
                      </li>
                    ))}

                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((prev) => prev + 1)}
                      disabled={currentPage === totalPages}
                      style={{ borderRadius: "10px" }}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            )}
          </>
        ) : (
          <div
            className="text-center"
            style={{
              padding: "36px",
              color: "#5F6B7A",
              fontWeight: 600,
            }}
          >
            <h6 className="fw-bold mb-1" style={{ color: "#334155" }}>
              No audit logs found
            </h6>
            <p className="mb-0">
              Try changing the date range or search keyword.
            </p>
          </div>
        )}
      </div>
    </section>
  );
}

const inputStyle = {
  borderRadius: "12px",
  padding: "11px 14px",
  border: "1px solid #EEF0F4",
  fontSize: "14px",
};

const thStyle = {
  textAlign: "center",
  background: "#F8FAFC",
  color: "#475569",
  fontSize: "12px",
  fontWeight: 800,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  borderBottom: "1px solid #EEF0F4",
  padding: "13px 14px",
  whiteSpace: "nowrap",
};

const thStyleLeft = {
  ...thStyle,
  textAlign: "left",
};

const tdStyle = {
  textAlign: "center",
  padding: "12px 14px",
  color: "#334155",
  fontWeight: 600,
  letterSpacing: "0.5px",
  verticalAlign: "middle",
  whiteSpace: "nowrap",
};

const tdStyleLeft = {
  ...tdStyle,
  textAlign: "left",
};

export default AuditLogs;
